import { Role, MODULES, ActiveLicenses } from '@core/types';

export interface MenuItem {
    title: string;
    pageName?: string;
    path?: string;
    action?: string;
    activeAction?: string;
    active?: boolean;
    label?: string;
    exact?: boolean;
    description?: string;
    hidden?: boolean;
    nonClickable?: boolean;
    license?: ActiveLicenses | ActiveLicenses[];
    role?: string;
    module?: string;
    component?: string;
    requiresGateway?: boolean;
    items?: MenuItem[] | null;
    skipMigration?: boolean;
}

export interface MenuCategory {
    license?: ActiveLicenses | ActiveLicenses[];
    module?: string;
    items: MenuItem[];
}

export interface MenuData {
    [key: string]: MenuCategory;
}

export const MENU_DATA: MenuData = {
    '': {
        items: [
            {
                action: 'bi bi-grid',
                activeAction: 'bi bi-grid-fill',
                title: 'myShops',
                path: '/myshops',
                active: false,
                label: '',
                exact: true,
                description: 'descriptions.myShops'
            },
            {
                action: 'bi bi-house-gear',
                activeAction: 'bi bi-house-gear-fill',
                title: 'manageShop',
                active: false,
                label: '',
                items: [
                    {
                        title: 'shopSetup',
                        pageName: '',
                        active: false,
                        label: '',
                        path: '/manage-shop/shopsetup',
                        exact: true,
                        role: Role.SuperAdmin,
                        description: 'shopSetup'
                    },
                    {
                        title: 'remoteControl',
                        pageName: '',
                        path: '/manage-shop/remote-control',
                        license: ActiveLicenses.ShopAutomation,
                        label: '',
                        exact: true,
                        description: 'descriptions.remoteControl'
                    },
                    {
                        title: 'descriptions.administrationOperationModesSchedules',
                        pageName: '',
                        active: false,
                        label: '',
                        path: '/manage-shop/operationModesSchedules',
                        exact: true,
                        description: 'descriptions.administrationOperationModesSchedules',
                        license: ActiveLicenses.ShopAutomation
                    },
                    {
                        title: 'recycleBin',
                        pageName: '',
                        active: false,
                        label: '',
                        items: [
                            {
                                title: 'modules',
                                pageName: '',
                                active: false,
                                label: '',
                                path: '/manage-shop/recyclebin/:id/modules',
                                exact: true,
                                role: Role.SuperAdmin
                            }
                        ],
                        path: '/manage-shop/recyclebin',
                        exact: true,
                        role: Role.SuperAdmin,
                        description: 'descriptions.administrationRecycleBin'
                    }
                ]
            },
            {
                action: 'bi bi-clipboard-data',
                activeAction: 'bi bi-clipboard-data-fill',
                title: 'statistics',
                active: false,
                label: '',
                items: [
                    {
                        title: 'events',
                        pageName: '',
                        path: '/statistics/events',
                        active: false,
                        label: '',
                        exact: true,
                        description: 'descriptions.eventProtocol'
                    },
                    {
                        action: 'zmdi-border-all',
                        title: 'zoneTracker',
                        license: ActiveLicenses.ShopAutomation,
                        module: MODULES.ZONE_TRACKER,
                        active: false,
                        label: '',
                        skipMigration: false,
                        path: '/statistics/zonetracker/overview',
                        description: 'descriptions.zoneTrackerOverview',
                        items: [
                            {
                                title: 'dailyDetails',
                                pageName: '',
                                path: '/statistics/zonetracker/dailydetails',
                                license: ActiveLicenses.ShopAutomation,
                                label: '',
                                exact: true,
                                description: 'descriptions.zoneTrackerDailyDetails',
                                hidden: true
                            },
                            {
                                title: 'dailyComparison',
                                pageName: '',
                                path: '/statistics/zonetracker/dailycomparison',
                                license: ActiveLicenses.ShopAutomation,
                                label: '',
                                exact: true,
                                description: 'descriptions.zoneTrackerDailyComparison',
                                hidden: true
                            },
                            {
                                title: 'entries',
                                pageName: '',
                                path: '/statistics/zonetracker/entries',
                                license: ActiveLicenses.ShopAutomation,
                                label: '',
                                exact: true,
                                description: 'descriptions.zoneTrackerEntries',
                                hidden: true
                            },
                            {
                                title: 'dwellTime',
                                pageName: '',
                                path: '/statistics/zonetracker/dwelltime',
                                license: ActiveLicenses.ShopAutomation,
                                label: '',
                                exact: true,
                                description: 'descriptions.zoneTrackerDwellTime',
                                hidden: true
                            },
                            {
                                title: 'overview',
                                pageName: '',
                                path: '/statistics/zonetracker/overview',
                                license: ActiveLicenses.ShopAutomation,
                                label: '',
                                exact: true,
                                description: 'descriptions.zoneTrackerOverview',
                                hidden: true
                            }
                        ]
                    },
                    {
                        action: 'zmdi-view-headline',
                        title: 'lineTracker',
                        license: ActiveLicenses.ShopAutomation,
                        module: MODULES.LINE_TRACKER,
                        active: false,
                        label: '',
                        path: '/statistics/linetracker/relations',
                        description: 'descriptions.lineTrackerRelations',
                        items: [
                            {
                                title: 'relations',
                                pageName: '',
                                path: '/statistics/linetracker/relations',
                                license: ActiveLicenses.ShopAutomation,
                                label: '',
                                exact: true,
                                description: 'descriptions.lineTrackerRelations',
                                hidden: true
                            }
                        ]
                    },
                    {
                        action: 'zmdi-view-carousel',
                        title: 'gates',
                        requiresGateway: true,
                        active: false,
                        label: '',
                        nonClickable: true,
                        items: [
                            {
                                title: 'insights',
                                pageName: '',
                                path: '/statistics/gates/insights',
                                label: '',
                                exact: true,
                                description: 'descriptions.gatesInsights'
                            },
                            {
                                title: 'openings',
                                pageName: '',
                                path: '/statistics/gates/openings',
                                label: '',
                                exact: true,
                                description: 'descriptions.gatesOpenings'
                            },
                            {
                                title: 'details',
                                pageName: '',
                                path: '/statistics/gates/details',
                                label: '',
                                exact: true,
                                description: 'descriptions.gatesDetails'
                            }
                        ]
                    },
                    {
                        action: 'zmdi-cast zmdi-hc-rotate-180',
                        title: 'rfid',
                        license: ActiveLicenses.Rfid,
                        module: MODULES.TROLLEY_SHELTER,
                        active: false,
                        label: '',
                        nonClickable: true,
                        items: [
                            {
                                title: 'overview',
                                pageName: '',
                                path: '/statistics/rfid/overview',
                                license: ActiveLicenses.Rfid,
                                module: MODULES.TROLLEY_SHELTER,
                                label: '',
                                exact: true,
                                description: 'descriptions.trolleyShelterOverview'
                            },
                            {
                                title: 'dailyDetails',
                                pageName: '',
                                path: '/statistics/rfid/dailydetails',
                                license: ActiveLicenses.Rfid,
                                label: '',
                                exact: true,
                                description: 'descriptions.trolleyShelterDailyDetails'
                            },
                            {
                                title: 'dailyComparison',
                                pageName: '',
                                path: '/statistics/rfid/dailycomparison',
                                license: ActiveLicenses.Rfid,
                                label: '',
                                exact: true,
                                description: 'descriptions.trolleyShelterDailyComparison'
                            },
                            {
                                title: 'monitoring',
                                pageName: '',
                                license: ActiveLicenses.Rfid,
                                module: MODULES.TROLLEY_SHELTER,
                                active: false,
                                label: '',
                                exact: true,
                                path: '/statistics/rfid/monitoring',
                                description: 'descriptions.monitoringTrolleyShelter'
                            }
                        ]
                    },
                    {
                        action: 'zmdi-tv-list',
                        title: 'fastLaner',
                        license: ActiveLicenses.FastLaner,
                        active: false,
                        label: '',
                        nonClickable: true,
                        items: [
                            {
                                title: 'overview',
                                pageName: '',
                                license: ActiveLicenses.FastLaner,
                                active: false,
                                label: '',
                                exact: true,
                                path: '/statistics/fastLaner/overview',
                                description: 'descriptions.fastLanerOverview'
                            },
                            {
                                title: 'fastLanerHealth',
                                pageName: '',
                                license: ActiveLicenses.FastLaner,
                                active: false,
                                label: '',
                                exact: true,
                                path: '/statistics/fastLaner/health',
                                description: 'descriptions.fastLanerHealth'
                            }
                        ]
                    },
                    {
                        action: 'zmdi-lock',
                        title: 'hybridLoc',
                        license: ActiveLicenses.HybridLoc,
                        active: false,
                        label: '',
                        nonClickable: true,
                        items: [
                            {
                                title: 'dailyUsage',
                                pageName: '',
                                path: '/statistics/hybridloc/daily-usage',
                                license: ActiveLicenses.HybridLoc,
                                label: '',
                                exact: true,
                                description: 'descriptions.hybridLocDailyUsage'
                            },
                            {
                                title: 'detailedUsage',
                                pageName: '',
                                path: '/statistics/hybridloc/detailed-usage',
                                license: ActiveLicenses.HybridLoc,
                                label: '',
                                exact: true,
                                description: 'descriptions.hybridLocDetailedUsage'
                            },
                            {
                                title: 'appCoinUsage',
                                pageName: '',
                                path: '/statistics/hybridloc/appcoin-usage',
                                license: ActiveLicenses.HybridLoc,
                                label: '',
                                exact: true,
                                description: 'descriptions.appCoinUsage'
                            },
                            {
                                title: 'hybridLocBattery',
                                pageName: '',
                                license: ActiveLicenses.HybridLoc,
                                active: false,
                                label: '',
                                exact: true,
                                path: '/statistics/hybridloc/battery',
                                description: 'descriptions.hybridLocBattery'
                            }
                        ]
                    },
                    {
                        title: 'dataExports',
                        pageName: '',
                        active: false,
                        label: '',
                        path: '/statistics/dataexports',
                        exact: true,
                        role: Role.SuperAdmin,
                        description: 'descriptions.administrationDataExports',
                        license: [ActiveLicenses.Rfid, ActiveLicenses.ShopAutomation, ActiveLicenses.HybridLoc]
                    }
                ]
            },
            {
                action: 'bi bi-building-gear',
                activeAction: 'bi bi-building-fill-gear',
                title: 'manageOrganisation',
                active: false,
                label: '',
                role: Role.UnitAdmin,
                items: [
                    {
                        title: 'organisations',
                        pageName: '',
                        active: false,
                        label: '',
                        path: '/manage-organisation/organisations',
                        exact: true,
                        role: Role.SuperAdmin,
                        description: 'descriptions.userManagementOrganisations'
                    },
                    {
                        title: 'mediaPlayerTemplates',
                        pageName: '',
                        active: false,
                        label: '',
                        path: '/manage-organisation/mediaPlayerTemplates',
                        exact: true,
                        role: Role.SuperAdmin,
                        description: 'descriptions.mediaPlayerTemplates',
                        license: [ActiveLicenses.ShopAutomation]
                    },
                    {
                        title: 'notificationTemplates',
                        pageName: '',
                        active: false,
                        label: '',
                        path: '/manage-organisation/notificationtemplates',
                        exact: true,
                        role: Role.UnitAdmin,
                        description: 'descriptions.administrationNotificationTemplates'
                    },
                    {
                        title: 'fastLanerSettings',
                        pageName: '',
                        active: false,
                        label: '',
                        path: '/manage-organisation/fastLanerSettings',
                        exact: true,
                        role: Role.SuperAdmin,
                        description: 'descriptions.administrationFastLaner',
                        license: [ActiveLicenses.FastLaner]
                    },
                    {
                        title: 'rfidTags',
                        pageName: '',
                        active: false,
                        label: '',
                        path: '/manage-organisation/rfidtags',
                        exact: true,
                        role: Role.SuperAdmin,
                        description: 'descriptions.administrationRfidTags',
                        license: ActiveLicenses.Rfid
                    },
                    {
                        title: 'products',
                        pageName: '',
                        active: false,
                        label: '',
                        path: '/manage-organisation/products',
                        exact: true,
                        role: Role.SuperAdmin,
                        description: 'descriptions.administrationProducts',
                        license: ActiveLicenses.Rfid
                    },
                    {
                        title: 'operationModes',
                        pageName: '',
                        active: false,
                        label: '',
                        path: '/manage-organisation/operationModes',
                        exact: true,
                        role: Role.SuperAdmin,
                        description: 'descriptions.administrationOperationModes',
                        license: ActiveLicenses.ShopAutomation
                    },
                    {
                        title: 'authenticationProviders',
                        pageName: '',
                        active: false,
                        label: '',
                        path: '/manage-organisation/authenticationProviders',
                        exact: true,
                        role: Role.SuperAdmin,
                        description: 'descriptions.administrationAuthenticationProviders',
                        license: ActiveLicenses.ShopAutomation
                    },
                    {
                        title: 'logicServiceManagement',
                        pageName: '',
                        active: false,
                        label: '',
                        path: '/manage-organisation/logic-service-management',
                        exact: true,
                        role: Role.SuperAdmin,
                        description: 'descriptions.logicServiceManagement',
                        license: ActiveLicenses.ShopAutomation
                    },
                    {
                        title: 'info',
                        pageName: '',
                        active: false,
                        label: '',
                        path: '/manage-organisation/info',
                        exact: true,
                        role: Role.SuperAdmin,
                        description: 'descriptions.administrationInfo'
                    },
                    {
                        title: 'designElements',
                        pageName: '',
                        active: false,
                        label: '',
                        path: '/manage-organisation/design-elements',
                        exact: true,
                        role: Role.SuperAdmin,
                        description: 'descriptions.administrationDesignElements'
                    }
                ]
            },
            {
                action: 'bi bi-person-gear',
                activeAction: 'bi bi-person-fill-gear',
                title: 'manageUsers',
                active: false,
                label: '',
                role: Role.StoreAdmin,
                items: [
                    {
                        title: 'users',
                        pageName: '',
                        active: false,
                        label: '',
                        path: '/manage-users/users',
                        exact: true,
                        role: Role.StoreAdmin,
                        description: 'descriptions.manageUsers'
                    },
                    {
                        title: 'superAdmins',
                        pageName: '',
                        active: false,
                        label: '',
                        path: '/manage-users/superAdmins',
                        exact: true,
                        role: Role.SuperAdmin,
                        description: 'descriptions.manageSuperAdmins'
                    }
                ]
            },
            {
                action: 'zmdi-tv-list',
                title: 'smartShelf',
                license: ActiveLicenses.SmartShelf,
                skipMigration: true,
                active: false,
                label: '',
                items: [
                    {
                        title: 'smartShelves',
                        pageName: '',
                        license: ActiveLicenses.SmartShelf,
                        active: false,
                        label: '',
                        exact: true,
                        path: '/monitoring/smartshelf',
                        description: 'descriptions.monitoringSmartShelf',
                        skipMigration: true
                    }
                ]
            },
            {
                title: 'releaseNotes',
                pageName: '',
                active: false,
                label: '',
                exact: true,
                path: '/release-notes',
                description: 'descriptions.releaseNotes',
                hidden: true
            }
        ]
    }
};

// Utility function to get menu data
export const getMenuData = (): MenuData => MENU_DATA;
